/* __next_internal_client_entry_do_not_use__ LanguageSelector auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import styled from "styled-components";
import { HoverItem } from "./HoverItem";
import { LanguageSelectorDropdown } from "./LanguageSelectorDropdown";
import { LanguageSelectorText } from "./LanguageSelectorText";
/**
 * @trackcomponent
 * @link [Docs](https://slate.faire.team/component/language-selector)
 */ export var LanguageSelector = function(props) {
    return /*#__PURE__*/ _jsx(LanguageSelectorWrapper, {
        hoverChild: /*#__PURE__*/ _jsx(LanguageSelectorDropdown, _object_spread({}, props)),
        position: props.position === "up" ? "top" : "bottom",
        "data-test-id": "languageDropdown",
        children: /*#__PURE__*/ _jsx(LanguageSelectorText, _object_spread({}, props))
    });
};
var LanguageSelectorWrapper = styled(HoverItem).withConfig({
    componentId: "sc-c293b449-0"
})([
    "position:relative;width:min-content;"
]);
